import { faChevronDown, faChevronUp, faCreditCard, faInfoCircle, faPencil, faWarning } from '@fortawesome/pro-light-svg-icons'
import { numToDecimals } from '@teinor/erp/prices'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import { Fragment, useCallback, useMemo, useRef, useState } from 'react'
import ComponentRowRender from '../../../../../../../../../baseComponents/ComponentRowRender'
import { ComponentRowRenderSchema } from '../../../../../../../../../baseComponents/ComponentRowRender/types'
import { CalculateParamsTy } from '../../../../../../../../../baseComponents/Displays/DisplayPrice/types'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import TwinIcon, { TwinIconProp } from '../../../../../../../../../baseComponents/TwinIcon'
import { ITDisplayNumber, ITDisplayPriceNotRounded, ITIconToolTip } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { BuildedOrder } from '../../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import { RectangularInputFormatNumberSmallStateFull } from '../../../../../../../../../forms/Input'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import { usePlainMeasureDictionary } from '../../../../../../../../../utils/hooks/useMeasureDictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { getConfigParam, getPreparePricesConfigParam, getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import { orderTotalHeaderIconDecider } from './functions'
import { nanoid } from 'nanoid'
import { financialRowCalculationTypesInversed, financialRowTypesInversed, FooterTotalsResult, HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import { InputTableLayoutData, OrderHeaderURLs } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { UserPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { ITLayoutTableModalOpen, ITLayoutTableModalOpenSetTy } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import useOrderTypeShippingDict from '../../../../../../../../../utils/hooks/orders/useOrderTypeShippingDict'
import { ButtonSecondary } from '../../../../../../../../../baseComponents/Button'
import { EditCardTabsHorizontalWithoutLinks } from '../../../../../../../../../baseComponents/EditCardTabs'
import { ModalFullCentered } from '../../../../../../../../../baseComponents/Modal'
import { ComponentTabObject } from '../../../../../../../../../utils/hooks/useTabLogic'
import { ProductTypesPayload } from '../../../../../../../../../utils/reducers/products/productTypes'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import { RowRendererOrderTotalWithoutAcc, RowRendererTotalsByAccount } from '../../../../../OrderTotal/FooterOrderTotal'
import useBuyTypeShippingDict from '../../../../../../../../../utils/hooks/buys/useBuyTypeShipping'
import { HeaderOrderTotalNewBaseProps } from './types'
import { SetEditDeleteModalTy } from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import { displayFormatedNumber } from '../../../../../../../../../utils/globals/numbers'

interface HeaderOrderTotalProps {
    handleShow: () => void
    show: boolean
    totalsOrderTableData: FooterTotalsResult
    CurrencyId: string
    haveNotes?: boolean
    hideNotes?: boolean
    setOpenModal: SetEditDeleteModalTy
    OrderId: number
    orderStatus: number
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    OrderFinancialRows: TwinDictionary[]
    orderHeaderURLs: OrderHeaderURLs
    skipEdit: boolean
    userPermissions: UserPermissions
    orderStatusDict: TwinDictionary
    completeData: InputTableLayoutData
    total_payed?: number
}

const HeaderOrderTotal: React.FC<HeaderOrderTotalProps> = ({ setOpenModal, haveNotes, CurrencyId, show, handleShow, totalsOrderTableData, hideNotes, OrderId, getCompleteData, OrderFinancialRows, orderStatus, orderHeaderURLs, userPermissions, skipEdit, orderStatusDict, completeData, total_payed }) => {
    const decimals = getConfigParam('decimals') as TwinParameters['decimals']
    const firstColumns: ComponentRowRenderSchema<FooterTotalsResult['totals']> = []
    const beforeSubtotalAfterColumns: ComponentRowRenderSchema<FooterTotalsResult['totals']> = []
    let beforeTotalColumns: ComponentRowRenderSchema<FooterTotalsResult['totals']> = []
    const measures : any = usePlainMeasureDictionary()
    const { t } = useTwinTranslation()
    for (const unit of totalsOrderTableData.typeUnitsUsed) {
        const label = measures[unit]
        firstColumns.push(
            {
                label,
                dataKey: 'units',
                customRender: (value) => <ITDisplayNumber value={value[unit]} />,
                width: 55 + (totalsOrderTableData.totals.units[unit].toFixed(decimals).length * 7)
            },
        )
    }
    if (totalsOrderTableData.totals.subTotalProducts && totalsOrderTableData.totals.subTotalProducts !== totalsOrderTableData.totals.subtotal) {
        firstColumns.push(
            {
                label: t('subTotalProductsShort', 'Subtotal Prod.'),
                dataKey: 'subTotalProducts',
                customRender: (value) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 75 + (totalsOrderTableData.totals.subTotalProducts.toFixed(decimals).length * 9)
            },
        )
    } else if (totalsOrderTableData.totals.subtotal) {
        firstColumns.push({
            label: <TwinTrans transKey='subtotal'>Subtotal</TwinTrans>,
            dataKey: 'subtotal',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 35 + (totalsOrderTableData.totals.subtotal.toFixed(decimals).length * 14)
        })
    }
    if (totalsOrderTableData.totals.subTotalCosts) {
        firstColumns.push(
            {
                label: t('costs', 'Costes'),
                dataKey: 'subTotalCosts',
                customRender: (value) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 75 + (totalsOrderTableData.totals.subTotalCosts.toFixed(decimals).length * 9)
            },
        )
    }
     if (totalsOrderTableData.totals.discounts_before) {
        beforeSubtotalAfterColumns.push(
            {
                label: <TwinTrans transKey='discounts'>Descuentos</TwinTrans>,
                dataKey: 'discounts_before',
                customRender: (value) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 60 + (totalsOrderTableData.totals.discounts_before.toFixed(decimals).length * 11)
            },
        )
    }
     if (totalsOrderTableData.totals.recharge_before) {
        beforeSubtotalAfterColumns.push(
            {
                label: <TwinTrans transKey='recharges'>Recargos</TwinTrans>,
                dataKey: 'recharge_before',
                customRender: (value) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 55 + (totalsOrderTableData.totals.recharge_before.toFixed(decimals).length * 11)
            },
        )
    }
    if (totalsOrderTableData.totals.vatMoney2) {
        beforeTotalColumns.push(
            {
                label: t('rechargeTotal', 'Recargo total'),
                dataKey: 'vatMoney2',
                customRender: (value) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 75 + (totalsOrderTableData.totals.vatMoney2.toFixed(decimals).length * 7.5)
            }
        )
    }
    if (totalsOrderTableData.totals.recharge_after) {
        beforeTotalColumns.push(
            {
                label: t('financialRechargeShort', 'Recargo Fin.'),
                dataKey: 'recharge_after',
                customRender: (value) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
                width: 60 + (totalsOrderTableData.totals.recharge_after.toFixed(decimals).length * 11.5)
            }
        )
    }
    if (total_payed){
        const myTotalPayed = parseFloat(String(total_payed))
        const left = totalsOrderTableData.totals.total - myTotalPayed
        beforeTotalColumns.push(
            {
                label: t('totalPayed', 'Total pagado'),
                dataKey: 'total',
                customRender: (value) => <ITDisplayPriceNotRounded value={myTotalPayed} with_vat={false} CurrencyId={CurrencyId} />,
                width: 60 + (myTotalPayed.toFixed(decimals).length * 11.5)
            }
        )
        beforeTotalColumns.push(
            {
                label: t('totalLeft', 'Total Pend.'),
                dataKey: 'total',
                customRender: (value) => <ITDisplayPriceNotRounded value={left} with_vat={false} CurrencyId={CurrencyId} />,
                width: 60 + (left.toFixed(decimals).length * 11.5)
            }
        )
    }
    const columns: ComponentRowRenderSchema<FooterTotalsResult['totals']> = [
        ...firstColumns,
        ...beforeSubtotalAfterColumns,
        {
            label: <TwinTrans transKey='totalWithoutVat'>Base imponible</TwinTrans>,
            dataKey: 'subTotalAfter',
            customRender: (value,) => {
                if (orderStatus === orderStatusDict['creating']) {
                    return <ITDisplayEditFinalPriceFooterBase OrderId={OrderId} value={value} CurrencyId={CurrencyId} getCompleteData={getCompleteData} OrderFinancialRows={OrderFinancialRows} beforeTax={true} orderHeaderURLs={orderHeaderURLs} skipEdit={skipEdit} />
                }
                return <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />
            },
            width: 75 + (totalsOrderTableData.totals.subTotalAfter.toFixed(decimals).length * (orderStatus === orderStatusDict['creating'] ? 12 : 9.5))
        },
        {
            label: <TwinTrans transKey='vats'>Impuestos</TwinTrans>,
            dataKey: 'vatMoney',
            customRender: (value, allValues) => <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />,
            width: 55 + (totalsOrderTableData.totals.vatMoney.toFixed(decimals).length * 11)
        },
        ...beforeTotalColumns,
        {
            label: <span className='bold18 uppercase'><TwinTrans transKey='total'>Total</TwinTrans></span>,
            dataKey: 'total',
            customRender: (value, allValues) => {
                if (orderStatus === orderStatusDict['creating']) {
                    return <ITDisplayEditFinalPriceFooterBase OrderId={OrderId} value={value} CurrencyId={CurrencyId} getCompleteData={getCompleteData} OrderFinancialRows={OrderFinancialRows} beforeTax={false} orderHeaderURLs={orderHeaderURLs} skipEdit={skipEdit} />       
                }
                return <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={CurrencyId} />
            },
            width: (orderStatus === orderStatusDict['creating'] ? 65 : 30) + (totalsOrderTableData.totals.total.toFixed(decimals).length * (orderStatus === orderStatusDict['creating'] ? 14 : 14.5))
        }
    ]
    const permissionKey = Object.keys(userPermissions)?.[0]
    const haveUpdatePermission = permissionCheck(getUserPermissions(permissionKey as any), 'update')
    return (
        <div className='bg-gray-F7 flex justify-end px-24 items-center input_table_footer_header'>
            <div className='input_table_footer_header_scroll'>
                <div className='input_table_footer_header_scroll gap-x-10'>
                    {(!haveNotes && !hideNotes && haveUpdatePermission) ? <ShowOrderNotesIcon setOpenModal={setOpenModal} label={t('addNotes', 'Añadir notas')} /> : null}
                    {<ShowOrderPaymentIcon setOpenModal={setOpenModal} label={t('paymentMethS', 'Mét. pago')} />}
                </div>
                <ComponentRowRender columns={columns} data={[totalsOrderTableData.totals]} />
            </div>
            <IconShowFooter {...{show, handleShow}} />
        </div>
    )
}

export type ITDisplayEditFinalPriceFooterBaseProps = ITDisplayEditFinalPriceFooterLogicProps & {
    value: number
    CurrencyId: string
    OrderFinancialRows: TwinDictionary[]
    skipEdit?: boolean
}

export const ITDisplayEditFinalPriceFooterBase: React.FC<ITDisplayEditFinalPriceFooterBaseProps> = ({ OrderId, value, getCompleteData, OrderFinancialRows, beforeTax, orderHeaderURLs, skipEdit, ...params }) => {
    const { t } = useTwinTranslation()
    const { editPrice, handleEditPrice, myOnBlur, ref, id } = useITDisplayEditFinalPriceFooterLogic({ OrderId, value, getCompleteData, OrderFinancialRows, beforeTax, orderHeaderURLs })
    return (
        <div className='flex items-center input_price w-full' ref={ref} >
            {editPrice ?
                <RectangularInputFormatNumberSmallStateFull className='edit_total_input w-75' onBlur={myOnBlur} initialValue={value} />
                :
                <ITDisplayPriceNotRounded value={value} with_vat={false} CurrencyId={params.CurrencyId} className={(skipEdit ? 'mr-0 ' : ' ') + (!beforeTax ? 'font-bold ' : ' ')} />
            }
            {!skipEdit ?
                <ITIconToolTip className='cursor-pointer hover:text-green-43 h-20 w-20 edit_hover_message_final_price' icon={faPencil} id={'editTotalPrice_' + OrderId + id} message={t('editTotalPrice', 'Editar precio total')} onClick={handleEditPrice} positionStrategy='fixed' place='top-end' />
                : null}
        </div>
    )
}

interface ITDisplayEditFinalPriceFooterLogicProps {
    OrderId: number
    value: number
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    OrderFinancialRows: TwinDictionary[]
    beforeTax: boolean
    orderHeaderURLs: OrderHeaderURLs
}

const useITDisplayEditFinalPriceFooterLogic = ({ OrderId, value, getCompleteData, OrderFinancialRows, beforeTax, orderHeaderURLs }: ITDisplayEditFinalPriceFooterLogicProps) => {
    const id = useMemo(() => nanoid(), [])
    const [editPrice, setEditPrice] = useState<boolean>(false)
    const ref = useRef<any>(null)
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy

    const handleEditPrice = useCallback(() => {
        setEditPrice((old) => !old)
        setTimeout(() => {
            const input = ref.current?.querySelector('.edit_total_input')
            if (input) {
                input.focus()
            }
        }, 40)
    }, [setEditPrice])

    const myOnBlur = useCallback(async (e: React.FocusEvent<HTMLInputElement>) => {
        let myValue = e.target.value
        myValue = myValue.replace(',', '.')
        if (myValue) {
            if (parseFloat(myValue) !== value) {
                let url = orderHeaderURLs.createFinancialRow
                let orderFinancialRowBeforeTax = null
                let orderFinancialRow = null
                const params: any = {
                    OrderId,
                    calculationType: financialRowCalculationTypesInversed['quantity'],
                    financialRowType: financialRowTypesInversed['discountForTotalFooter'],
                    beforeTax
                }
                for (const element of OrderFinancialRows) {
                    if (element.financialRowType === financialRowTypesInversed['discountForTotalFooter'] && element.beforeTax && beforeTax) {
                        orderFinancialRowBeforeTax = element
                        url = orderHeaderURLs.updateFinancialRow
                        params.id = element?.id
                    } else if (element.financialRowType === financialRowTypesInversed['discountForTotalFooter'] && !element.beforeTax && !beforeTax) {
                        orderFinancialRow = element
                        url = orderHeaderURLs.updateFinancialRow
                        params.id = element?.id
                    }
                }
                const discount = numToDecimals(value - parseFloat(myValue))
                const myOrderFinancialRow = orderFinancialRowBeforeTax ? orderFinancialRowBeforeTax : orderFinancialRow
                const finalDiscount = myOrderFinancialRow ? (numToDecimals(parseFloat(myOrderFinancialRow.quantity) + discount)) : discount
                const discountParsed = numToDecimals(finalDiscount, calculateParams.decimals)
                params.quantity = discountParsed
                const result = await twinFetchPostJSON(url, params)
                if (result) {
                    getCompleteData()
                }
            }
        }
        handleEditPrice()
    }, [handleEditPrice, OrderId, value, getCompleteData, calculateParams.decimals, OrderFinancialRows, beforeTax, orderHeaderURLs.createFinancialRow, orderHeaderURLs.updateFinancialRow])

    return { handleEditPrice, editPrice, myOnBlur, ref, id }
}

interface IconShowFooterProps {
    handleShow: () => void
    show: boolean
}

const IconShowFooter: React.FC<IconShowFooterProps> = ({handleShow, show}) => {
    return (<TwinIcon className='ml-15 cursor-pointer p-1' icon={orderTotalHeaderIconDecider(show)} onClick={handleShow} />)
}

interface ShowOrderNotesIconProps {
    setOpenModal: SetEditDeleteModalTy
    label: string
}

export const ShowOrderNotesIcon: React.FC<ShowOrderNotesIconProps> = ({ setOpenModal, label}) => {
    return (
        <div className='text-green-21 cursor-pointer flex items-center min-w-110 w-110' onClick={() => setOpenModal({ type: 'create', allRowData: {} })}>
            <TwinIcon icon={faPencil} className='w-19 h-19' />
            <span className='ml-8 mt-2'>{label}</span>
        </div>
    )
}

interface ShowOrderPaymentIconProps {
    setOpenModal: SetEditDeleteModalTy
    label: string
}

export const ShowOrderPaymentIcon: React.FC<ShowOrderPaymentIconProps> = ({ setOpenModal, label }) => {
    return (
        <div className='text-green-21 cursor-pointer flex items-center min-w-110 w-110' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })}>
            <TwinIcon icon={faCreditCard} className='w-19 h-19' />
            <span className='ml-8 mt-2'>{label}</span>
        </div>
    )
}

interface HeaderOrderTotalNewProps extends HeaderOrderTotalNewBaseProps {
    costs: TwinDictionary
    headerDataCalculate: HeaderDataCalculate
    setOpenModal: ITLayoutTableModalOpenSetTy
    headerData: TwinDictionary
    completeData: InputTableLayoutData
    modelId: string
    FooterOrderRowShortComponent: React.FC<any>
}

export const HeaderOrderTotalNew: React.FC<HeaderOrderTotalNewProps> = ({ CurrencyId, show, handleShow, totalsOrderTableData, costs, headerDataCalculate, headerData, hideLeftFooter, ...rest }) => {
    let renderComponent = <FooterHeaderClosedComponent {...{ totalsOrderTableData, headerData, CurrencyId, costs, handleShow, headerDataCalculate, show, hideLeftFooter, ...rest }} />
    if (show) {
        renderComponent = <FooterOrderTotalOpenedNewConnect totalsOrderTableData={totalsOrderTableData} CurrencyId={CurrencyId} costs={costs} headerDataCalculate={headerDataCalculate} />
    }
    return (
        <div className='bg-gray-F7 flex gap-15 justify-between px-24 py-17 items-center input_table_footer_header min-h-65 input_table_footer_header_new'>
            <ShowFullFooterDetailsIcon {...{ show, handleShow }} />
            {renderComponent}
        </div>
    )
}

interface ShowFullFooterDetailsIconProps {
    handleShow: (old: boolean) => void
    show: boolean
}

const ShowFullFooterDetailsIcon: React.FC<ShowFullFooterDetailsIconProps> = ({ handleShow, show }) => {
    const { t } = useTwinTranslation()
    const labelText = show ? t('hideDetails', 'Ocultar detalles') : t('seeFullTotalsDetails', 'Ver desglose')
    const labelTextShort = show ? t('hide', 'Ocultar') : t('see', 'Ver')
    return (
        <div className='see_full_footer_text text-green-21 gap-x-8 cursor-pointer flex items-center' onClick={(old) => handleShow(!old)}>
            <TwinIcon className={show ? 'mt-4' : 'mt-1'} icon={show ? faChevronUp : faChevronDown} />
            <span className='footer_details_text mt-2'>{labelText}</span>
            <span className='footer_details_text_short hidden mt-2'>{labelTextShort}</span>
        </div>
    )
}

const FooterHeaderClosedComponent: React.FC<HeaderOrderTotalNewProps> = ({ headerData, setOpenModal, totalsOrderTableData, CurrencyId, orderStatus, OrderFinancialRows, getCompleteData, OrderId, orderHeaderURLs, orderStatusDict, skipEdit, completeData,  ...rest }) => {
    let renderWithoutTaxPrice: JSX.Element = <ITDisplayPriceNotRounded value={totalsOrderTableData?.totals?.subTotalAfter} with_vat={false} CurrencyId={CurrencyId} className='regular20'  />
    if (orderStatus === orderStatusDict['creating']) {
        renderWithoutTaxPrice = <ITDisplayEditFinalPriceFooterBase OrderId={OrderId} value={totalsOrderTableData?.totals?.subTotalAfter} CurrencyId={CurrencyId} getCompleteData={getCompleteData} OrderFinancialRows={OrderFinancialRows} beforeTax={true} orderHeaderURLs={orderHeaderURLs} skipEdit={skipEdit} {...{ completeData }} />
    }
    let renderFinalPrice: JSX.Element = <ITDisplayPriceNotRounded value={totalsOrderTableData?.totals?.total} with_vat={false} CurrencyId={CurrencyId} className='medium20' />
    if (orderStatus === orderStatusDict['creating']) {
        renderFinalPrice = <ITDisplayEditFinalPriceFooterBase OrderId={OrderId} value={totalsOrderTableData?.totals?.total} CurrencyId={CurrencyId} getCompleteData={getCompleteData} OrderFinancialRows={OrderFinancialRows} beforeTax={false} orderHeaderURLs={orderHeaderURLs} skipEdit={skipEdit}  {...{ completeData }} />
    }
    let renderTotalPayed: JSX.Element | null  = null
    if(completeData.header.total_payed){
        renderTotalPayed = <Fragment>
            <div className='regular16 mt-1'><TwinTrans transKey='totalPayed'>Total a pagar</TwinTrans></div>
            <ITDisplayPriceNotRounded value={completeData.header.total_payed} with_vat={false} CurrencyId={CurrencyId} className='regular20' />
        </Fragment>
    }
    let renderTotalToPay: JSX.Element | null = null
    if (completeData.header.total_to_pay){
        renderTotalToPay = <Fragment>
            <div className='regular16 mt-1'><TwinTrans transKey='totalPend'>Total pend.</TwinTrans></div>
            <ITDisplayPriceNotRounded value={completeData.header.total_to_pay} with_vat={false} CurrencyId={CurrencyId} className='regular20' />
        </Fragment>
    }
    return (
        <div className='flex flex-auto gap-x-8 gap-y-5 flex-row items-center justify-between input_table_footer_header_totals_container'>
            <div className='vertical_line_footer_divider mr-5 border-r-2 border-gray-D6 h-28'></div>
            <FooterHeaderRowRenderNew totalsOrderTableData={totalsOrderTableData} setOpenModal={setOpenModal} headerData={headerData} {...rest} />
            <div className='flex gap-x-15 gap-y-5 ml-auto flex-row items-center justify-end input_table_footer_header_totals_parent'>
                <div className='flex footer_total_without_vat gap-x-10 whitespace-nowrap items-center justify-end'>
                    {renderTotalPayed}
                    {renderTotalToPay}
                    <div className='regular16 mt-1'><TwinTrans transKey='totalWithoutVat'>Base imponible</TwinTrans></div>
                    {renderWithoutTaxPrice}
                </div>
                <div className='flex gap-x-10 whitespace-nowrap items-center justify-end'>
                    <div className='medium16 uppercase mt-1'><TwinTrans transKey='total'>Total</TwinTrans></div>
                    {renderFinalPrice}
                </div>
            </div>
        </div>
    )
}

interface FooterHeaderRowRenderNewProps {
    modelId: string
    totalsOrderTableData: FooterTotalsResult
    setOpenModal: ITLayoutTableModalOpenSetTy
    headerData: TwinDictionary
    isReadOnly?: boolean
    hideLeftFooter: undefined | boolean
    FooterOrderRowShortComponent: React.FC<FooterRowConfigInputBaseProps>
}

const FooterHeaderRowRenderNew: React.FC<FooterHeaderRowRenderNewProps> = ({ totalsOrderTableData, setOpenModal, headerData, isReadOnly, hideLeftFooter, FooterOrderRowShortComponent, modelId }) => {
    const measures: any = usePlainMeasureDictionary()
    const renderFields: JSX.Element[] = []

    for (const unit of totalsOrderTableData.typeUnitsUsed) {
        const label = measures[unit]
        renderFields.push(
            <FooterRowInput label={label} value={displayFormatedNumber(totalsOrderTableData.totals.units[unit])} className='medium14' key={label + 'div'} />
        )
    }
    if (!hideLeftFooter) {
        renderFields.push(
            <FooterOrderRowShortComponent headerData={headerData} isReadOnly={isReadOnly} setOpenModal={setOpenModal} key={'short_footer'} modelId={modelId}/>
        )
    }
    return (
        <div className='flex header_row_render_content gap-x-20 gap-y-5 items-center min-h-30'>
            {renderFields}
        </div>
    )
}

export interface FooterRowConfigInputBaseProps {
    modelId: string
    headerData: TwinDictionary
    isReadOnly: undefined | boolean
    setOpenModal: (value: React.SetStateAction<ITLayoutTableModalOpen>) => void
}

export const FooterRowSellShortComponent: React.FC<FooterRowConfigInputBaseProps> = ({ headerData, isReadOnly, setOpenModal, modelId }) => {
    const {t} = useTwinTranslation()
    const dictTypeSellOrderShipping = useOrderTypeShippingDict()
    const dictTypeShipping = dictTypeSellOrderShipping
    const isShipping = headerData?.typeShipping === 0 || headerData?.typeShipping
    return (
        <Fragment>
            <FooterRowInput label={t('transport', 'Transporte')} value={(!isShipping) ? t('add', 'Añadir') : dictTypeShipping[parseInt(String(headerData?.typeShipping))]?.name} onClick={(!isShipping) ? () => setOpenModal({ type: 'configShipping', allRowData: headerData }) : () => { }} className={'cursor-pointer ' + (!isShipping ? 'text-green-21' : 'medium14')} children={isShipping ? <IconHeaderFooterIcon id='edit_shipping_icon' message={t('editShipping', 'Editar transporte')} messageComplete={t('infoShipping', 'Información sobre el transporte')} onClick={() => setOpenModal({ type: 'configShipping', allRowData: headerData })} icon={faPencil} iconComplete={faInfoCircle} {...{ isReadOnly: isReadOnly || false }} /> : null} />
            <FooterRowSellShipping {...{ headerData, isReadOnly, setOpenModal, modelId }}/>
        </Fragment>
    )
}

interface FooterRowSellShippingProps extends FooterRowConfigInputBaseProps {}

const FooterRowSellShipping: React.FC<FooterRowSellShippingProps> = ({ headerData, modelId, isReadOnly, setOpenModal}) => {
    const { t } = useTwinTranslation()

    if(modelId === 'SellInvoiceId'){
        const hasPayment = headerData?.PayMCopy
        const havePaymentDates = headerData?.PayMCopy?.PayMCopyDates?.length>0
        return (
            <FooterRowInput label={t('paymentMethodS', 'Mét. pago')} value={!hasPayment ? t('add', 'Añadir') : headerData?.PayMCopy.name} onClick={() => setOpenModal({ type: 'configPaymentMethod', allRowData: { ...headerData, isReadOnly: headerData.status > sellInvoiceStatusInversed['waitingResponse'], url: '/api/app/order/sell/sellInvoice/assignPaymentMethodToSellInvoice' } })} className={'cursor-pointer ' + (!hasPayment ? 'text-green-21' : (!havePaymentDates ? 'text-yellow-B9' : 'medium14'))} children={hasPayment ? <IconHeaderFooterIcon id={'id_payment_icon'} message={t('editPayment', 'Editar Mét. pago')} messageComplete={t('infoPaymentMethod', 'Información sobre el mét. pago')}  icon={!havePaymentDates ? faWarning : faCreditCard} className={!havePaymentDates?'hover:text-yellow-B9' : ''} iconComplete={faInfoCircle} onClick={() => setOpenModal({ type: 'configPaymentMethod', allRowData: { ...headerData, isReadOnly: headerData.status > sellInvoiceStatusInversed['waitingResponse'], url: '/api/app/order/sell/sellInvoice/assignPaymentMethodToSellInvoice' } })} {...{ isReadOnly: isReadOnly || false }} /> : null} />
        )
    }
    const hasPayment = headerData?.PaymentMethod || headerData?.PayMCopy
    const myPayment = headerData?.PaymentMethod || headerData?.PayMCopy
    return (
        <FooterRowInput label={t('paymentMethodS', 'Mét. pago')} value={!hasPayment ? t('add', 'Añadir') : myPayment?.name} onClick={() => setOpenModal({ type: 'configPaymentMethodSimple', allRowData: headerData })} className={'cursor-pointer ' + (!hasPayment ? 'text-green-21' : 'medium14')} children={hasPayment ? <IconHeaderFooterIcon id={'id_payment_icon'} message={t('editPayment', 'Editar Mét. pago')} messageComplete={t('infoPaymentMethod', 'Información sobre el mét. pago')} icon={faCreditCard} iconComplete={faInfoCircle} onClick={() => setOpenModal({ type: 'configPaymentMethodSimple', allRowData: headerData })} {...{ isReadOnly: isReadOnly || false }} /> : null} />
    )
}

export const FooterRowBuyShortComponent: React.FC<FooterRowConfigInputBaseProps> = ({ headerData, isReadOnly, setOpenModal }) => {
    const {t} = useTwinTranslation()
    const dictTypeBuyOrderShipping = useBuyTypeShippingDict()
    const dictTypeShipping = dictTypeBuyOrderShipping
    const isShipping = headerData?.typeShipping === 0 || headerData?.typeShipping
    return (
        <FooterRowInput label={t('transport', 'Transporte')} value={(!isShipping) ? t('add', 'Añadir') : dictTypeShipping[parseInt(String(headerData?.typeShipping))]?.name} onClick={() => setOpenModal({ type: 'configShipping', allRowData: headerData })} className={'cursor-pointer ' + (!isShipping ? 'text-green-21' : 'medium14')} children={isShipping ? <IconHeaderFooterIcon id='edit_shipping_icon' message={t('editShipping', 'Editar transporte')} messageComplete={t('infoShipping', 'Información sobre el transporte')} onClick={() => setOpenModal({ type: 'configPaymentMethod', allRowData: headerData })} icon={faPencil} iconComplete={faInfoCircle} {...{ isReadOnly: isReadOnly || false }} /> : null} />
    )
}

interface FooterRowInputProps {
    label: string
    className?: string
    onClick?: () => void
    value: string | number
    children?: React.ReactNode
}

const FooterRowInput: React.FC<FooterRowInputProps> = ({ label, className, onClick, value, children }) => {
    return (
        <div className='flex gap-x-5'>
            <span>{label + ':'}</span>
            <div className={(className || '') + ' flex twin_elipsis footer_row_input_text'} onClick={onClick}>{value}</div>
            {children}
        </div>
    )
}

interface IconHeaderFooterIconProps {
    isReadOnly: boolean
    id: string
    message: string
    messageComplete: string
    onClick: ()=>void
    icon: TwinIconProp
    iconComplete: TwinIconProp
    className?: string
}

const IconHeaderFooterIcon: React.FC<IconHeaderFooterIconProps> = ({ id, message, messageComplete, icon, iconComplete, onClick, isReadOnly, className }) => {
    if (!isReadOnly) {
        return <ITIconToolTip className={'cursor-pointer hover:text-green-43 h-16 w-16 light14 ' + (className || '')} icon={icon} id={id} message={message} onClick={onClick} positionStrategy='fixed' />
    }

    return (<ITIconToolTip className={'cursor-pointer hover:text-green-43 h-16 w-16 light14 ' + (className || '')} icon={iconComplete} id={id} message={messageComplete} onClick={onClick} positionStrategy='fixed' />)
}

interface FooterOrderTotalOpenedProps {
    totalsOrderTableData: FooterTotalsResult
    CurrencyId: string
    costs: TwinDictionary
    headerDataCalculate: HeaderDataCalculate
 }

const FooterOrderTotalOpenedNew: React.FC<FooterOrderTotalOpenedProps> = ({ totalsOrderTableData, CurrencyId, headerDataCalculate, costs }) => {
    const { t } = useTwinTranslation()
    const { tabActive, setTabActive } = useFooterOrderTotalOpenedNewLogic()
    const tabs: ComponentTabObject = {
        'totalsWithoutVat': { component: RowRendererOrderTotalWithoutAcc, text: t('totalsWithoutVat', 'Bases imponibles') },
    }
    if (headerDataCalculate?.OrderAccounts?.length) {
        tabs['byChapters'] = { component: RowRendererTotalsByAccount, text: t('byChapters', 'Por capítulos') }
    }
    return (
        <div className='flex items-center flex-auto gap-x-20 justify-end'>
            <div className='text-green-21 twin_elipsis cursor-pointer' onClick={() => setTabActive('totalsWithoutVat')}>
                <TwinTrans transKey={'totalsWithoutVat'}>Bases imponibles</TwinTrans>
            </div>
            {headerDataCalculate?.OrderAccounts?.length ?
                <div className='text-green-21 twin_elipsis cursor-pointer' onClick={() => setTabActive('byChapters')}>
                    <TwinTrans transKey={'byChapters'}>Por capítulos</TwinTrans>
                </div>
                : null}
            {tabActive.length ? <ModalFullCentered opened={true} setOpened={() => setTabActive('')} onClickOut={true} className='flex modal_footer_order_total_accounts'>
                <div className='flex flex-auto flex-col modal_footer_order_total_accounts_container'>
                    <h2 className='flex justify-start regular20'><TwinTrans  transKey='WithoutVats'>Bases imponibles</TwinTrans></h2>
                    <EditCardTabsHorizontalWithoutLinks tabs={tabs} tab={tabActive} onClick={setTabActive} extraComponentData={{ totalsOrderTableData, CurrencyId, headerDataCalculate, costs }} className='footer_order_total_accounts_tabs mt-34 flex_tabs' />
                    <ButtonSecondary onClick={() => setTabActive('')} className='w-100 ml-auto mt-30 regular14'>
                        <TwinTrans transKey='back'>Volver</TwinTrans>
                    </ButtonSecondary>
                </div>
            </ModalFullCentered> : null}
        </div>
    )
}

const useFooterOrderTotalOpenedNewLogic = () => {
    const [tabActive, setTabActive] = useState<string>('')
    return { tabActive, setTabActive }
}

const footerOrderTotalDispatch = {
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}
export type ReduxFooterOrderTotal = ConnectedProps<typeof FooterOrderTotalOpenedNewConnect>
const mapFooterOrderTotalConnector = (state: AllReduxPayloads) => ({ productTypes: state.productTypes })
const footerOrderTotalConnect = connect(mapFooterOrderTotalConnector, footerOrderTotalDispatch)
const FooterOrderTotalLoading = withLoading(FooterOrderTotalOpenedNew, [{ fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' }])
const FooterOrderTotalOpenedNewConnect = footerOrderTotalConnect(FooterOrderTotalLoading)

export default HeaderOrderTotal